module.exports = __webpack_public_path__ + "img/PAY.ee4a219e.svg";